import {Datagrid, Filter, FunctionField, TextField, TextInput, TopToolbar} from "react-admin";
import React from "react";
import CrudMod from "../../../Component/Layouts/Button/CrudMod";
import CreateGradientButtonMod from "../../../Component/Layouts/Button/CreateGradientButtonMod";
import ListMod from "../../../Component/Redesign/ListMod";

const Filters = (props) => (
    <Filter {...props}>
        <TextInput variant="standard" label="Search" source="search" alwaysOn/>
    </Filter>
);

const LocalsField = ({record}) => {
    if (!record.locales || !record.locales.length) {
        return '';
    }

    const lastElement = record.locales.length - 1;
    return record.locales.map((item, i) => (
        <span key={i}>{item.locale}{i === lastElement ? '' : ', '}</span>
    ))
};

export const Groups = (props) => {
    const ListActions = ({className}) => {
        return (<TopToolbar className={className}>
            <div className="actionsWrap">
                <div className="addCategoryBtnWrap">
                    <CreateGradientButtonMod label={'Add New Group'}/>
                </div>
            </div>
        </TopToolbar>);
    };

    return (
        <div className="customTableWrap">
            <ListMod {...props} title="Groups" filters={<Filters/>} actions={<ListActions/>}
                     resource="groups/general" sort={{field: 'name', order: 'ASC'}}>
                <Datagrid bulkActionButtons={false} className="customTable categories-table">
                    <TextField label='Name' source="name" sortBy="name"/>
                    <FunctionField label='Description' source="description" sortBy="description" render={(record) => {
                        return (
                            <span title={record.description}>{record.description}</span>
                        );
                    }}/>
                    <FunctionField label='Localization' source="locales" sortBy="locales" render={(record) => {
                        return <LocalsField record={record}/>
                    }}/>
                    <FunctionField label="" source="actions" render={(record) => {
                        return <CrudMod edit="true" del="true" id={record.id} record={record}/>;
                    }}/>
                </Datagrid>
            </ListMod>
        </div>
    )
}

export default Groups;
